import { render, staticRenderFns } from "./dictionaries.vue?vue&type=template&id=ff6bbc18&scoped=true"
import script from "./dictionaries.vue?vue&type=script&lang=js"
export * from "./dictionaries.vue?vue&type=script&lang=js"
import style0 from "./dictionaries.vue?vue&type=style&index=0&id=ff6bbc18&lang=scss&scoped=true"
import style1 from "./dictionaries.vue?vue&type=style&index=1&id=ff6bbc18&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6bbc18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-manage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff6bbc18')) {
      api.createRecord('ff6bbc18', component.options)
    } else {
      api.reload('ff6bbc18', component.options)
    }
    module.hot.accept("./dictionaries.vue?vue&type=template&id=ff6bbc18&scoped=true", function () {
      api.rerender('ff6bbc18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/parameter/dictionaries.vue"
export default component.exports